import React from 'react';
import UserContext from './UserContext';

interface ComponentProps {
    children: JSX.Element
}

const TecoShopsContextProvider = ({ children }: ComponentProps) => {
    const [user, setUser] = React.useState();
    const [settings, setSettings] = React.useState(undefined);
    const [shoppingCart, setShoppingCart] = React.useState();
    const [token, setToken] = React.useState();
    const [isTokenVerified, setIsTokenVerified] = React.useState();


    return <UserContext.Provider
        value={
            {
                user,
                token,
                shoppingCart,
                settings,
                isTokenVerified,
                setIsTokenVerified,
                setUser,
                setToken,
                setSettings,
                setShoppingCart
            }
        }>
        {children}
    </ UserContext.Provider >

}

export default TecoShopsContextProvider